import React from 'react'
import { Link } from 'react-router-dom'

const  Email = () => {
  return (
    <>
    <div className="page-wrapper">
  <div className="content">
    <div className="page-header">
      <div className="row">
        <div className="col">
          <h3 className="page-title">Receive Fax</h3>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-3 col-md-12">
        <div className="compose-btn">
          <Link
            to="#"
            className="btn btn-primary btn-block w-100"
            data-bs-toggle="modal"
                        data-bs-target="#add_compose"
          >
            Compose
          </Link>
        </div>
        <ul className="inbox-menu">
          <li className="active">
            <Link to="#">
              <i className="fas fa-download" /> Inbox{" "}
              <span className="mail-count">(5)</span>
            </Link>
          </li>
          <li>
            <Link to="#">
              <i className="far fa-star" /> Important
            </Link>
          </li>
          <li>
            <Link to="#">
              <i className="far fa-paper-plane" /> Sent Mail
            </Link>
          </li>
          <li>
            <Link to="#">
              <i className="far fa-file-alt" /> Drafts{" "}
              <span className="mail-count">(13)</span>
            </Link>
          </li>
          <li>
            <Link to="#">
              <i className="far fa-trash-alt" /> Trash
            </Link>
          </li>
        </ul>
      </div>
      <div className="col-lg-9 col-md-12">
        <div className="card">
          <div className="card-body">
            <div className="email-header">
              <div className="row">
                <div className="col-lg-9 top-action-left col-sm-12">
                  <div className="float-left">
                    <div className="btn-group dropdown-action me-1">
                      <button
                        type="button"
                        className="btn btn-white dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        Select <i className="fas fa-angle-down" />
                      </button>
                      <div className="dropdown-menu">
                        <Link className="dropdown-item" to="#">
                          All
                        </Link>
                        <Link className="dropdown-item" to="#">
                          None
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          Read
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Unread
                        </Link>
                      </div>
                    </div>
                    <div className="btn-group dropdown-action me-1">
                      <button
                        type="button"
                        className="btn btn-white dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        Actions <i className="fas fa-angle-down" />
                      </button>
                      <div className="dropdown-menu">
                        <Link className="dropdown-item" to="#">
                          Reply
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Forward
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Archive
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          Mark As Read
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Mark As Unread
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          Delete
                        </Link>
                      </div>
                    </div>
                    <div className="btn-group dropdown-action me-1">
                      <button
                        type="button"
                        className="btn btn-white dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        <i className="fas fa-folder" />{" "}
                        <i className="fas fa-angle-down" />
                      </button>
                      <div role="menu" className="dropdown-menu">
                        <Link className="dropdown-item" to="#">
                          Social
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Forums
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Updates
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          Spam
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Trash
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          New
                        </Link>
                      </div>
                    </div>
                    <div className="btn-group dropdown-action me-1">
                      <button
                        type="button"
                        data-bs-toggle="dropdown"
                        className="btn btn-white dropdown-toggle"
                      >
                        <i className="fas fa-tags" />{" "}
                        <i className="fas fa-angle-down" />
                      </button>
                      <div role="menu" className="dropdown-menu">
                        <Link className="dropdown-item" to="#">
                          Work
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Family
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Social
                        </Link>
                        <div className="dropdown-divider" />
                        <Link className="dropdown-item" to="#">
                          Primary
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Promotions
                        </Link>
                        <Link className="dropdown-item" to="#">
                          Forums
                        </Link>
                      </div>
                    </div>
                    <div className="btn-group dropdown-action mail-search">
                      <input
                        type="text"
                        placeholder="Search Messages"
                        className="form-control search-message"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 top-action-right col-sm-12">
                  <div className="text-end ">
                    <button
                      type="button"
                      title="Refresh"
                      data-toggle="tooltip"
                      className="btn btn-white d-none d-md-inline-block me-1"
                    >
                      <i className="fas fa-sync-alt" />
                    </button>
                    <div className="btn-group">
                      <Link to="#" className="btn btn-white">
                        <i className="fas fa-angle-left" />
                      </Link>
                      <Link to="#" className="btn btn-white">
                        <i className="fas fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div className="text-end">
                    <span className="text-muted d-none d-md-inline-block">
                      Showing 10 of 112{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="email-content">
              <div className="table-responsive">
                <table className="table table-inbox table-hover">
                  <thead>
                    <tr>
                      <th colSpan={6}>
                        <label className="checkboxs">
                          <input type="checkbox" id="select-all" />
                          <span className="checkmarks" />
                        </label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="unread clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="fas fa-star starred" />
                        </span>
                      </td>
                      <td className="name">John Doe</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td>
                        <i className="fas fa-paperclip" />
                      </td>
                      <td className="mail-date">13:14</td>
                    </tr>
                    <tr className="unread clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">Envato Account</td>
                      <td className="subject">
                        Important account security update from Envato
                      </td>
                      <td />
                      <td className="mail-date">8:42</td>
                    </tr>
                    <tr className="clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">Twitter</td>
                      <td className="subject">HRMS Bootstrap Admin Template</td>
                      <td />
                      <td className="mail-date">30 Nov</td>
                    </tr>
                    <tr className="unread clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">Richard Parker</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td />
                      <td className="mail-date">18 Sep</td>
                    </tr>
                    <tr className="clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">John Smith</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td />
                      <td className="mail-date">21 Aug</td>
                    </tr>
                    <tr className="clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">me, Robert Smith (3)</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td />
                      <td className="mail-date">1 Aug</td>
                    </tr>
                    <tr className="unread clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">Codecanyon</td>
                      <td className="subject">Welcome To Codecanyon</td>
                      <td />
                      <td className="mail-date">Jul 13</td>
                    </tr>
                    <tr className="clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">Richard Miles</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td>
                        <i className="fas fa-paperclip" />
                      </td>
                      <td className="mail-date">May 14</td>
                    </tr>
                    <tr className="unread clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star" />
                        </span>
                      </td>
                      <td className="name">John Smith</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td />
                      <td className="mail-date">11/11/16</td>
                    </tr>
                    <tr className="clickable-row">
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <span className="mail-important">
                          <i className="far fa-star starred" />
                        </span>
                      </td>
                      <td className="name">Mike Litorus</td>
                      <td className="subject">
                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                      </td>
                      <td />
                      <td className="mail-date">10/31/16</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    {/* Add compose*/}
    <div className="modal fade" id="add_compose" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Send New Fax</h5>
            <button
              className="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form >
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                Recipient Fax Number
                </label>
                <div className="mb-2 input-group">
                                        <span className="input-group-text">
                                          <i className="ti-user" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Please enter 10 digits Number"
                                        />
                                      </div>
              </div>
              <div className="input-group mb-3">
              <label className="col-form-label">
              Select the phone number you wish to send fax from
                </label>
                <div className="mb-2 input-group">
                            <span className="input-group-text"><i className="ti-user"></i></span>
                            <select className="form-select" name="extension" id="extension">
                            <option value="" >Please Select Any</option>
                                
                                                                <option value="15061 ">Alex Goffery  - 15061</option>
                                
                                
                                                                <option value="18341 ">Allan Corpuz  - 18341</option>
                                
                                
                                                                <option value="18018 ">Anthony Montalvo  - 18018</option>
                                
                                
                                                                <option value="18451 ">Anthony Sandoval  - 18451</option>
                                
                                
                                                                <option value="13926 ">Arya Saliany  - 13926</option>
                                
                                
                                                                <option value="19311 ">Brady Thompson  - 19311</option>
                                
                                
                                                                <option value="13284 ">Brittany Nills  - 13284</option>
                                
                                
                                                                <option value="18009 ">Brittney Tomkalski  - 18009</option>
                                
                                
                                                                <option value="13156 ">Caleb Christensen  - 13156</option>
                                
                                
                                                                <option value="16108 ">Carla Abbasi  - 16108</option>
                                
                                
                                                                <option value="18005 ">Carson Harrison  - 18005</option>
                                
                                
                                                                <option value="18026 ">Charles Ripepe  - 18026</option>
                                
                                
                                                                <option value="18257 ">David Fennell  - 18257</option>
                                
                                
                                                                <option value="18011 ">Donnie Walsh  - 18011</option>
                                
                                
                                                                <option value="16615 ">Enzo David  - 16615</option>
                                
                                
                                                                <option value="16882 ">Ha Nguyen  - 16882</option>
                                
                                
                                                                <option value="14590 ">Harold Libbert  - 14590</option>
                                
                                
                                                                <option value="18063 ">Jacob Nisim  - 18063</option>
                                
                                
                                                                <option value="14776 ">Jishnu T  - 14776</option>
                                
                                
                                                                <option value="12218 ">Ken Howard  - 12218</option>
                                
                                
                                                                <option value="17232 ">Kyle Howard  - 17232</option>
                                
                                
                                                                <option value="16689 ">Landon Liga  - 16689</option>
                                
                                
                                                                <option value="18006 ">Michael Chacon  - 18006</option>
                                
                                
                                                                <option value="16595 ">Nick Harelick  - 16595</option>
                                
                                
                                                                <option value="13909 ">Patrick Mingione  - 13909</option>
                                
                                
                                                                <option value="18555 ">Peter Faggioni  - 18555</option>
                                
                                
                                                                <option value="15077 ">Renewals Development  - 15077</option>
                                
                                
                                                                <option value="18111 ">Richard Romero  - 18111</option>
                                
                                
                                                                <option value="18015 ">Sal Zottoli  - 18015</option>
                                
                                
                                                                <option value="36027 ">Samiksha Agarwal  - 36027</option>
                                
                                
                                                                <option value="13835 ">Sean Maurice  - 13835</option>
                                
                                
                                                                <option value="18007 ">Steve Crosby  - 18007</option>
                                
                                
                                                                <option value="17983 ">Test Test  - 17983</option>
                                
                                
                                                                <option value="13719 ">test test  - 13719</option>
                                
                                
                                                                <option value="11921 ">Test Test  - 11921</option>
                                
                                
                                                                <option value="17316 ">Test Test  - 17316</option>
                                
                                
                                                                <option value="12373 ">Test test2  - 12373</option>
                                
                                
                                                                <option value="13910 ">Tyson Elwood  - 13910</option>
                                
                                
                                                                <option value="13058 ">William Mingione  - 13058</option>
                                
                                
                                                                <option value="15004 ">Zach Christiansen  - 15004</option>
                                
                                
                                                                <option value="17208 ">Zak Grotenstein  - 17208</option>
                                
                                
                            </select>
                            </div>
                            </div>
                            <div className="form-group">
                                <input type="file" name="pdf_file" id="pdf_file"/>
                                <p className="help-block">Max. 10MB (Only pdf files are allowed)</p>
                            </div>
            </div>
            <div className="modal-footer">
              <div className="d-flex align-items-center justify-content-end m-0">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                 Discard
                </Link>
                <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                Email
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    {/* /Add compose */}
</>
  )
}

export default Email
